export const LoadingEvents = {
  OPEN: "OPEN-LOADING",
  CLOSE: 'CLOSE-LOADING'
};